import { render, staticRenderFns } from "./supplementing-materials-details.vue?vue&type=template&id=16ec58c4&scoped=true"
import script from "./supplementing-materials-details.vue?vue&type=script&lang=js"
export * from "./supplementing-materials-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ec58c4",
  null
  
)

export default component.exports